enum EnumJobContainerStatus {
	ContainerDisposed = 0,
	ContainerCreating = 1,
	ContainerCreatingError = 2,
	Ready = 3,
	Running = 4,
	ContainerTerminating = 5
}
export default EnumJobContainerStatus
